// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#warnTip .login-logo[data-v-3bcd7e74] {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n}\n#warnTip .warningTip[data-v-3bcd7e74] {\n  margin-top: 20px;\n  font-size: 20px;\n}\n#warnTip .warningTip a[data-v-3bcd7e74] {\n    color: #653EB3;\n    text-decoration: underline;\n}\n#warnTip .warningTip .lastTip[data-v-3bcd7e74] {\n    margin-left: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
